import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-894262d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "run-status-wrap" }

import OverallRun from './_components/overall-run/overall-run.vue'
import CoreServices from '@/views/dashboard/manage/run-status/_components/core-services/core-services.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'run-status',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(OverallRun, { style: {"height":"260px"} }),
    _createVNode(CoreServices, { style: {"flex":"1"} })
  ]))
}
}

})